import { TUTORIALS_LIST_UPDATE } from '../types'

const state = {
  tutorials: {
    rastreabilityModal: false,
    tourOfCurrentPage: false,
    whatsapp: false,
    busca: false,
    printTagTutorial: false
  }
}

const mutations = {
  [TUTORIALS_LIST_UPDATE](state, itemList) {
    state.tutorials[itemList.tutorial] = itemList.action
  }
}

const getters = {
  tutorialsList: state => {
    return state.tutorials
  }
}

const actions = {
  updateTutorialsList: ({ commit }, itemList) => {
    commit(TUTORIALS_LIST_UPDATE, itemList)
  }
}

export default { state, mutations, actions, getters }
export { mutations, actions, getters }
